<template>
    <ListModule
        :label="$t('components.smart.featuredCompanies.label')"
        :data="data"
        :to="companyURL()"
        :isLoading="loading()"
    />
</template>

<script>
export default {
    name: 'FeaturedCompanies',
    data() {
        return {
            doublePromotion: {},
            singlePromotion: {
                2095: true, //A.P. Moller - Maersk
                3102: true, //Arrow
                1249: true, //Credit Suisse
                2092: true, //Danish Crown
                169: true, //Deutsche Bank
                1260: true, //FDM Group
                2268: true, //Marsh & McLennan Companies
                2084: true, //N26
                2083: true, //PepsiCo
                2167: true, //RWE
                2130: true, //Sanofi
                1268: true, //Total
                2963: true, //UCB
                2204: true, //Western Union
            },
        };
    },
    computed: {
        featuredPostings() {
            return this.$interfaces.company.get({
                reactive: true,
            });
        },
        data() {
            let data = this.featuredPostings.data;
            if (!data) return [];
            return [
                /*
                ...data
                    .filter(it => this.doublePromotion[it.id])
                    .sort(() => 0.5 - Math.random())
                    .slice(0, 0),
                */
                ...data
                    .filter(it => this.singlePromotion[it.id])
                    .sort(() => 0.5 - Math.random())
                    .slice(0, 5),
            ].map(value => ({
                id: value.id,
                header: value.name,
                subheader: ''.concat(
                    value.country || '',
                    value.country && value.location ? ', ' : '',
                    value.location || ''
                ),
                image: value.logo,
            }));
        },
    },
    methods: {
        loading() {
            return this.featuredPostings.loading;
        },
        error() {
            return this.featuredPostings.error;
        },
        companyURL: function() {
            return this.$URLS.findcompanies;
        },
    },
};
</script>

<style scoped></style>
